/* Arrow-key movement inside The Archive's panel.

   WHY THIS EXISTS AT ALL, GIVEN TAB ALREADY WORKS

   The panel is a set of plain links inside a <details> disclosure, and for that
   pattern Tab is the correct and expected way through — this is not an ARIA
   menu, and turning it into one would mean taking the links out of the tab
   order, which is a worse trade for a reader using a keyboard because it is
   less like every other list of links in the shop.

   So this is additive and nothing depends on it. Tab still walks every row in
   reading order; the arrows are a faster way down a list of twelve, for a
   reader who reaches for them. Removing this file changes no capability.

   WHAT IT DELIBERATELY DOES NOT DO

   - It does not wrap at the ends. Focus stops on the last row rather than
     leaping back to the first, because a jump you did not ask for reads as a
     bug, and Tab is right there as the way out of the panel.
   - It does not touch ArrowLeft / ArrowRight. In a single mobile column there
     is nothing horizontal to mean; the desktop panel has columns and can give
     them a meaning that is actually true there.
   - It does not preventDefault on anything it did not handle, so page scroll,
     type-ahead and every browser shortcut are untouched.
*/
(function () {
  'use strict';

  var KEYS = { ArrowDown: 1, ArrowUp: -1, Home: 'first', End: 'last' };

  function rows(panel) {
    // Anchors only. The book in preparation is a <span> by design — it has
    // nowhere to go — so it is not in this list, and arrowing past it is what
    // a reader would expect from a row that is not a link.
    return Array.prototype.slice.call(panel.querySelectorAll('a.archive-panel__link'));
  }

  document.addEventListener('keydown', function (event) {
    var move = KEYS[event.key];
    if (!move) return;

    var panel = event.target.closest && event.target.closest('.archive-panel');
    if (!panel) return;

    var items = rows(panel);
    if (items.length === 0) return;

    var index = items.indexOf(document.activeElement);
    if (index === -1) return;

    var next;
    if (move === 'first') next = 0;
    else if (move === 'last') next = items.length - 1;
    else next = index + move;

    // Clamped, not wrapped. See the note above.
    if (next < 0 || next >= items.length) return;

    event.preventDefault();
    items[next].focus();
  });
})();
